import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-family-reg',
  templateUrl: './add-family-reg.component.html',
  styleUrls: ['./add-family-reg.component.css']
})
export class AddFamilyRegComponent implements OnInit {
  data: any ={};
  constructor() { }

  ngOnInit() {
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onSubmit() {
    alert(JSON.stringify(this.data));
  }
  
}
